import React from 'react';
import { string, number, bool } from 'prop-types';

import SvgIcon from '../svg-icon';
import { ROUTES } from '../../routes/constants';
import {
  Card,
  ErrorPageWrap,
  ErrorPageContent,
  LinkButton,
  Title,
  Description,
} from './styles';

export const ErrorPage = ({
  code,
  title,
  isFullPage,
  description,
}) => (
  <ErrorPageWrap isFullPage={isFullPage}>
    <Card>
      <SvgIcon isWithoutHover type="sadApiko" />
      <ErrorPageContent>
        <Title>
          <span>{code}</span> {title}
        </Title>
        <Description>
          {description}
        </Description>
        <LinkButton href={ROUTES.OVERVIEW}>
          Home
        </LinkButton>
      </ErrorPageContent>
    </Card>
  </ErrorPageWrap>
);


ErrorPage.propTypes = {
  isFullPage: bool,
  code: number.isRequired,
  title: string.isRequired,
  description: string.isRequired,
};

ErrorPage.defaultProps = {
  isFullPage: true,
};



// WEBPACK FOOTER //
// ./src/components/error-page/error-page.js